export const CHILD_DOB_KEY = 'dob';
export const COUNTRY_LIST_LANGUAGE = 'en';
export const COUNTRY_LIST_TYPE = 'official';
export const daysOfWeek = {
    mon: "Monday",
    tue: "Tuesday",
    wed: "Wednesday",
    thu: "Thursday",
    fri: "Friday",
    //sat: "Saturday",
    //sun: "Sunday"
};
export const daysOfWeekMap = {
    sun: "sunday",
    mon: "monday",
    tue: "tuesday",
    wed: "wednesday",
    thu: "thursday",
    fri: "friday",
    sat: "saturday"
};
export const SESSION_KEY_USER_DATA = 'userData';
export const SESSION_KEY_JWT = 'jwtToken';
export const SESSION_KEY_CART_COUNT_ITEMS = 'cart_total';
export const SESSION_KEY_CART_ITEMS = 'cart_items';
export const SESSION_KEY_ORDER_UUID = 'order_uuid';
export const SESSION_KEY_PAYMENT_METHOD = 'payment_method';
export const SESSION_KEY_CLIENT_ID = 'client_id';
export const SESSION_KEY_LOCATION_ID = 'location_id';
export const SESSION_KEY_WEBSITE = 'website';
export const SESSION_KEY_PHONE = 'phone';
export const SESSION_KEY_EMAIL = 'email';
export const SESSION_KEY_ADDRESS = 'address';
export const SESSION_KEY_COUNTRY_CODE = 'country_code';
export const SESSION_KEY_POSTAL = 'postal';
export const SESSION_KEY_GROUP_ID = 'group_id';
export const SESSION_KEY_USER_ORDERS_DATA = 'user_orders';
export const SESSION_KEY_LOGO_URL = 'logo_url';
export const SESSION_KEY_COMPANY_NAME = 'company_name';
export const KEY_ORDER_TYPE_DEPOSIT = 'deposit';
export const KEY_ORDER_TYPE_EMPTY = '0';
export const KEY_ORDER_TYPE_FULL = 'full';
export const KEY_PARENTS_API_TYPE_PARENT = 'event parent';
export const KEY_PARENTS_API_TYPE_CHILD = 'events';
export const MESSAGE_LOGIN_PAYER_ID_UNDEFINED = 'This email address is associated with a Kindertales user account that does not have payment privileges. Please contact the primary guardian on the account to request those privileges. <br/><p class="p-small-info">NOTE: Signing up with a new email address will create new child accounts within Kindertales. We don’t recommend doing this, as it will create duplicates and the new accounts will not be associated with the current account you are a part of.</p>';
export const KEY_COUPON_TYPE_PERCENTAGE = 2;
export const ALL_EVENTS_GROUP = {id: "0", name: 'All Events', description: '\u00A0'};
export const KEY_COUPON_LOCATION_ID_ALL = 0;
export const DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm:ss';
export const TIME_FORMAT = 'HH:mm:ss';
export const KEY_CHARGE_ONE_TIME_PAYMENT = 7;
export const PRICING_STATUS_ACTIVE = 1;
export const KEY_EVENT_STATUS_ACTIVE = 1;
export const SESSION_KEY_UTM_PARAMS = 'utm_params';